import React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@material-ui/core/styles';
import { Typography, Avatar, Container, Paper, AppBar, Box, IconButton, Toolbar, Button } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import MenuIcon from '../../icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import HomeIcon from '@material-ui/icons/Home';
import ReplayIcon from '@material-ui/icons/Replay';
import Modal from '@material-ui/core/Modal';

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  paddingTop: '0',
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    color: theme.palette.primary.contrastText
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none'
  }),
  [theme.breakpoints.up('lg')]: {
    paddingLeft: '280px'
  },
  zIndex: theme.zIndex.drawer - 100,
  transition: theme.transitions.create(['padding', 'width'], {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.enteringScreen
  })
}));

const DashboardNavbar = (props) => {
  const { openMobile, onMobileClose, onSidebarMobileOpen, ...other } = props;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400
  };

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ height: 64 }}>
        {!openMobile && (
          <IconButton
            color="inherit"
            onClick={onSidebarMobileOpen}
            sx={{
              display: {
                lg: 'none'
              }
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
        )}
        {openMobile && (
          <IconButton
            color="inherit"
            onClick={onMobileClose}
            sx={{
              display: {
                lg: 'none'
              }
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
        )}
        <Box
          sx={{
            flexGrow: 1
          }}
        />
        {!openMobile && (
          <>
            <IconButton sx={{ mr: 0 }} onClick={handleOpen} color="inherit">
              <ReplayIcon />
            </IconButton>
            <IconButton color="inherit" href="/" target="_blank">
              <HomeIcon />
            </IconButton>
          </>
        )}
        <Button
          sx={{
            ml: 1,
            display: {
              lg: 'block',
              md: 'none',
              sm: 'none',
              xs: 'none'
            }
          }}
          href="tel:7777777777"
          color="secondary"
          variant="contained"
        >
          Call Us
        </Button>
      </Toolbar>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Container maxWidth="sm">
            <Paper elevation={12} sx={{ p: 3 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <Avatar
                  sx={{
                    backgroundColor: (theme) => alpha(theme.palette.success.main, 0.08),
                    color: 'success.main',
                    mb: 2
                  }}
                >
                  <ReplayIcon />
                </Avatar>
                <Typography color="textPrimary" variant="h5">
                  Reset Configurator?
                </Typography>
                <Typography align="center" color="textSecondary" sx={{ mt: 1 }} variant="body2">
                  You will lose all your current settings if you reset.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  mt: 4
                }}
              >
                <Button color="secondary" fullWidth size="large" variant="contained" href="/" target="_self">
                  Reset
                </Button>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  mt: 1
                }}
              >
                <Button color="white" fullWidth size="large" variant="contained" onClick={handleClose}>
                  Cancel
                </Button>
              </Box>
            </Paper>
          </Container>
        </Box>
      </Modal>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onMobileClose: PropTypes.func,
  onSidebarMobileOpen: PropTypes.func,
  openMobile: PropTypes.bool
};

export default DashboardNavbar;
